
class SessionStorageService {

    getItem = (key: string): any | null => {
        const response = sessionStorage.getItem(key);
        return (response && JSON.parse(response)) || null;
    };

    setItem = (key: string, value: any) => {
        sessionStorage.setItem(key, JSON.stringify(value));
    };

    removeItem(key: string) {
        return sessionStorage.removeItem(key);
    }

    clear() {
        sessionStorage.clear();
    }
}

var sessionStorageService = new SessionStorageService();
export { sessionStorageService };
